export default "__VITE_ASSET__DlCsRo69__"